import { ifNumberValidThen } from '../utils';
import { getServerNumberConvertRatio } from '../config';
export function deflateServerNumber(input, country, currencyId) {
  return ifNumberValidThen(input, function (num) {
    return num / getServerNumberConvertRatio(country, currencyId);
  });
}
export function parseServerNumber(input, country, currencyId) {
  return ifNumberValidThen(input, function (num) {
    return Math.round(num * getServerNumberConvertRatio(country, currencyId));
  });
}